export default {
    addresses: {
        title: "Unos informacija za dostavu",
        fullName: {
            label: "Ime i prezime",
            placeholder: "Unesite ime i prezime"
        },
        firstName: {
            label: "Ime",
            placeholder: "Unesite ime"
        },
        lastName: {
            label: "Prezime",
            placeholder: "Unesite prezime"
        },
        phone: {
            label: "Broj telefona",
            placeholder: "Unesite broj mobilnog"
        },
        number: {
            label: "Broj ulice",
            placeholder: "Unesite broj ulice"
        },
        city: {
            label: "Grad",
            placeholder: "Odaberite grad"
        },
        address: {
            label: "Adresa (Samo Podgorica)",
            placeholder: "Unesite ulicu i broj",
            addNew: "Dodajte novu adresu",
            chooseAnother: "Odaberite drugu adresu",
            viewAll: "Pogledaj sve adrese"
        },
        primaryAddress: "Koristite ovu adresu kao glavnu.",
        backOnCartLink: "Nazad na narudžbinu",
        buttonApproval: "Potvrda",
        saveAddress: "Sačuvaj adresu"
    },
    chooseAddress: {
        title: "Unos informacija za dostavu",
        chooseAddress: 'Izaberite adresu:',
        addNewAddress: "Dodajte novu adresu",
        backOnCartLink: "Nazad na narudžbinu",
        buttonPayment: "Plaćanje",
        addressCard: {
            button: {
                edit: "Izmijeni",
                primaryAddress: "Glavna adresa",
                setPrimary: "Podesi kao glavnu adresu"
            }
        }
    },
    payment: {
        title: "Podaci o plaćanju",
        byCard: "Karticom",
        byCashOnDelivery: "Pouzećem",
        cvvInfo: 'CVV je trocifreni broj koji se obično nalazi na poleđini Vaše kartice.',
        infoMsg: "Iznos koji će se ukloniti sa Vaše kartice je prikazan na računu za Plaćanje online.",
        cardInfo: {
            title: "Informacije kartice",
            form: {
                firstName: {
                    label: "Ime",
                    placeholder: "Unesi ime"
                },
                lastName: {
                    label: "Prezime",
                    placeholder: "Unesi prezime"
                },
                cardNumber: {
                    label: "Broj kartice",
                    placeholder: "0000 0000 0000 0000"
                },
                validThru: {
                    label: "Datum validnosti",
                    placeholder: "MM / YY"
                },
                cvv: {
                    label: "CVV",
                    placeholder: "000"
                },
                nameOnCard: {
                    label: "Ime na kartici",
                    placeholder: "Ime i prezime"
                }
            }
        },
        cashOnDelivery: {
            infoMsg: `Određeni proizvodi nemaju opciju plaćanja pouzećem pa se ne mogu kupiti.
                    Ti proizvodi su uklonjeni iz narudžbine i prikazani u listi ispod.
                    Promjena načina plaćanja može vratiti ove proizvode u Vašu narudžbinu.`,
            removedProducts: 'Uklonjeni proizvodi',
            footerInfoMsg: 'Proizvodi iz ove liste su uklonjeni iz narudžbine jer nemaju opciju plaćanja pouzećem.'
        },
        checkbox: {
            option1: "Sačuvaj podatke kartice za buduće kupovine",
            option2: "Adresa naplate je ista kao i adresa za dostavu"
        },
        navigation: {
            back: "Informacije",
            forward: "Potvrda",
            backOnCart: "Nazad na korpu"
        },
        validationErrors: {
            'number_errors_blank': 'Polje broj kartice je obavezno.',
            'cvv_errors_blank': 'Polje CVV je obavezno.',
            'number_errors_invalid': 'Neispravan broj kartice.',
            'cvv_errors_invalid': 'Neispravan CVV kod.',
            'validThru_errors_blank': 'Polje datum validnosti je obavezno.',
            'validThru_errors_invalid': 'Datum validnosti nije validan.',
            'validThru_errors_expired': 'Kartica je istekla.',
            'first_name_errors_blank': 'Polje ime je je obavezno.',
            'last_name_errors_blank': 'Polje prezime je je obavezno.',
        }
    },
    approval: {
        title: "Potvrda podataka",
        subtitle: {
            deliveryInformation: "Adresa dostave",
            orderPreview: "Pregled narudžbine"
        },
        payment: {
            title: "Kartica",
            creditCard: "Kreditna kartica",
            cashOnDelivery: "Pouzećem",
            creditCardPayment: 'Iznos koji se plaća karticom:',
            cashOnDeliveryPayment: 'Iznos koji se plaća pouzećem:',
            back: 'Nazad',
            nameOnCard: 'Puno ime na kartici'
        },
        storeDelivery: 'Proizvodi koje dostavlja prodavnica',
        sellsAndGuarantees: 'prodaje i garantuje',
        forProducts: 'za proizvode.',
        note: "Napomena",
        addNote: "Dodaj napomenu prodavcu",
        notePlaceholder: "Ostavite napomenu prodavcu",
        agree: 'Pročitao(la) sam i slažem se sa',
        terms: 'uslovima plaćanja',
        delivery: 'Dostava za ovu prodavnicu je',
        navigation: {
            back: "Plaćanje",
            forward: "Potvrdi narudžbinu",
            backOnCart: "Nazad na korpu"
        },
    },
    pay: 'Plati'
}
